import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "icon"];
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { BaseButton } from '../primitives/base-button/index.js';
var Button = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var children = props.children,
      icon = props.icon,
      rest = _objectWithoutProperties(props, _excluded);

  return jsxs(BaseButton, _objectSpread(_objectSpread({
    ref: forwardedRef
  }, rest), {}, {
    children: [children ? jsx(BaseButton.Label, {
      children: children
    }) : null, icon ? jsx(BaseButton.Icon, {
      icon: icon
    }) : null]
  }));
});
Button.displayName = 'Button';
export { Button };